<template>
  <div class="privacy-policy" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <h1>プライバシーポリシー</h1>
    <p>メノア株式会社（以下「当運営者」といいます。）は、当運営者が管理するサービス「スクワットロッカー」（以下「本サービス」といいます。）におけるユーザーの情報の取り扱いについて、以下の通りプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</p>

    <h2>1. 本サービスの特徴</h2>
    <p>本サービスは、会員登録不要でご利用いただけるアプリです。ユーザーのスクワット記録等のデータは、ユーザーのデバイス内にのみ保存され、当運営者のサーバーには送信・保存されません。</p>

    <h2>2. カメラおよび映像データについて</h2>
    <p>本サービスはスクワットを検出するためにカメラを使用します。カメラ映像はAppleのVisionフレームワーク（体勢推定機能）を使用して、ユーザーのデバイス上でリアルタイムに処理されます。</p>
    <ul>
      <li>本サービスは顔データを一切収集・処理・保存しません</li>
      <li>カメラ映像は体の姿勢（腰・膝の位置）の検出にのみ使用されます</li>
      <li>映像データは当運営者のサーバーに送信されません</li>
      <li>映像データはユーザーのデバイスに保存されません</li>
      <li>処理はフレームごとに行われ、即座に破棄されます</li>
    </ul>

    <h2>3. 当運営者が取得する情報</h2>
    <p>本サービスでは、サービス改善およびアプリの安定性向上を目的として、以下の匿名化された情報を取得する場合があります。</p>
    <ul>
      <li>アプリのクラッシュレポート</li>
      <li>アプリの利用状況に関する統計情報（個人を特定できない形式）</li>
    </ul>
    <p>これらの情報は個人を特定するものではなく、サービス品質の向上のためにのみ使用されます。</p>

    <h2>4. 情報の利用目的</h2>
    <p>当運営者は取得した情報を以下の目的で利用いたします。</p>
    <ul>
      <li>本サービスの品質向上および不具合の改善のため</li>
      <li>本サービスの利用状況の分析のため</li>
    </ul>

    <h2>5. 第三者への情報提供</h2>
    <p>当運営者は、法令に基づく場合を除き、取得した情報を第三者に提供することはありません。</p>

    <h2>6. お問い合わせ</h2>
    <p>本ポリシーに関するお問い合わせは、以下のメールアドレス宛にご連絡ください。</p>
    <p>info@menoah.jp</p>

    <h2>7. プライバシーポリシーの改定</h2>
    <p>当運営者は、必要に応じて本ポリシーを改定することがあります。改定後のポリシーは、本サービス上または当運営者のウェブサイトに掲載した時点から効力を生じるものとします。</p>

    <p>2025年2月3日制定、2026年2月12日改定</p>
  </div>
</template>

<script>
export default {
  name: 'SquatLockerPrivacyPolicyView',
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    document.title = 'プライバシーポリシー | スクワットロッカー';
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped>
/* 共通スタイル - 見出し設定 */
h1 {
  color: var(--color-green-600);
}

h2 {
  font-size: 20px;
  color: var(--color-grey-500);
  margin-top: 32px;
}

p, li {
  color: var(--color-grey-500);
}

/* モバイル対応スタイル */
.mobile {
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 24px;
  padding-right: 24px;
}

.mobile h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.mobile h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 16px;
}

.mobile p, .mobile li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.mobile ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.mobile li {
  margin-bottom: 5px;
}

/* デスクトップ対応スタイル */
.desktop {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 80px;
  padding-right: 80px;
  max-width: 1120px;
  margin: 0 auto;
}

.desktop h1 {
  font-size: 28px;
  padding-bottom: 24px;
  text-align: left;
}

.desktop h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 24px;
}

.desktop p, .desktop li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.desktop ul {
  margin-bottom: 20px;
  padding-left: 20px;
}

.desktop li {
  margin-bottom: 8px;
}
</style>
